{
  "request": {
    "formExamples": {
      "itemName": "e.g. Recycled A4 paper",
      "unit": "e.g. box",
      "businessReason": "e.g. Restock paper for reception printing.",
      "specification": "e.g. A4, 80 gsm, recycled paper, 500 sheets per pack."
    },
    "draftRequest": "Draft request",
    "resumeDraft": "Resume draft",
    "cartWithCurrency": "Cart · {{currency}}",
    "draftNumberNote": "It gets a request number when it is submitted.",
    "returnedOn": "Returned {{date}}",
    "returnedBy": "Returned by {{name}}",
    "returnedByOn": "Returned by {{name}} on {{date}}",
    "quantityNotSaved": "The new quantity was not saved",
    "lineNotRemoved": "The line was not removed",
    "detailsNotSaved": "Your change to the request details was not saved",
    "resubmitFailed": "The request was not resubmitted",
    "reorderFailed": "The reorder did not go through",
    "cancelConsequence": "Cancelling stops this request for good, and it cannot be reopened. Any approval still waiting is closed, and any budget the request is holding is released.",
    "keepRequest": "Keep request",
    "onlyRequesterAmends": "Only the requester can amend this request",
    "onlyRequesterChangesDraft": "Only the requester can change this draft request",
    "atLastSubmission": "At the last submission, {{date}}",
    "asLastSubmitted": "Prices and totals are as at the last submission ({{date}}). Lines may have changed since; they are priced again when the request is resubmitted.",
    "currentNotResubmitted": "As it stands now, not yet resubmitted",
    "lineBlocked": "Cannot be ordered as it stands",
    "belowMinimum": "Minimum order is {{minimum}}. Increase the quantity to {{minimum}} or more.",
    "belowMinimumNoFigure": "The quantity is below the minimum order for this item. Increase it to continue.",
    "returnedPricesNext": "Prices of lines you have added or changed are confirmed when the request is checked. Amend the request to see them and resubmit it.",
    "notPricedYet": "Not priced yet",
    "draftPricesNext": "Prices are confirmed when the draft is checked. Resume the draft to see them and submit it.",
    "cartPricesNext": "Prices are confirmed when the cart is checked. Resume the draft to see them and submit the request.",
    "cancelConsequenceProcessing": "Cancelling stops this request for good, and it cannot be reopened. The framework agreement its award created, while still a draft, is withdrawn and can never be activated; an agreement that is already active is not changed. Any budget the request is holding is released.",
    "cancelReasonRequired": "Say why this request is being cancelled.",
    "returnToSourcing": "Return to sourcing",
    "returnToSourcingTitle": "Return this need to sourcing?",
    "returnToSourcingConsequence": "The award is withdrawn, and the draft agreement it created can never be activated. The need goes back to sourcing, where a new enquiry, with its own number, can be raised for it. Nothing is deleted: the earlier enquiry, its award and the agreement stay on record. An agreement that is already active must first be ended through its own lifecycle.",
    "returnToSourcingReasonRequired": "Say why the need goes back to sourcing.",
    "keepWithProcurement": "Keep it with procurement",
    "priceFromAgreement": "Price from the agreement",
    "priceFromAgreementTitle": "Price this request from its agreement?",
    "priceFromAgreementConsequence": "The same request is priced from its activated agreement line, its budget is reserved at that price, and any approval the policy asks for runs once, on this request. Nothing is ordered yet.",
    "priceAndReserve": "Price and reserve",
    "notNow": "Not now",
    "orderingTitle": "Ordering progress",
    "orderingSubtitle": "The request is recorded as ordered once every required supplier order is issued.",
    "orderingComplete": "Every required purchase order is issued.",
    "orderingIssued": "Issued orders",
    "orderingRemaining": "Still to order",
    "orderingNoOrderYet": "no order yet",
    "orderingLastFailure": "Last attempt failed: {{message}}",
    "orderingInternalHanded": "Lines served from a warehouse were handed to internal fulfilment.",
    "orderingBlocker": {
      "unsourced": "No supplier is set for this line.",
      "supplier_not_procurable": "The supplier cannot be bought from at the moment.",
      "no_order": "No purchase order has been generated for it yet.",
      "issue_failed": "Its purchase order could not be issued.",
      "order_draft": "Its purchase order is still a draft."
    }
  }
}
